
window.TrackJS && window.TrackJS.configure({
    version: VERSION
});

function setTrackJsContext(context) {

    if (window.TrackJS) {

        if (context !== null) {

            if (context.sessionId !== null) {
                window.TrackJS.configure({
                    sessionId: context.sessionId
                });
            }

            window.TrackJS.addMetadata("brandId", context.brandId);
            window.TrackJS.addMetadata("subBrandId", context.subBrandId);
            window.TrackJS.addMetadata("clientProductPackage", context.clientProductPackage);
            window.TrackJS.addMetadata("systemId", context.systemId);
            window.TrackJS.addMetadata("lang", context.lang);
            window.TrackJS.addMetadata("regulationId", context.regulationId);
            window.TrackJS.addMetadata("mode", context.mode);
        }
    }
}

function trackJsInfo(event, param) {
    window.TrackJS.console.info(event, param);
}


export { setTrackJsContext, trackJsInfo }